document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) toggle.addEventListener('click', () => { const open = nav.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', String(open)); });

  const productForm = document.querySelector('.product-form');
  if (!productForm) return;
  const variantsNode = document.querySelector('[data-product-json]');
  const select = productForm.querySelector('[data-product-select]');
  const price = document.querySelector('[data-product-price]');
  const add = productForm.querySelector('[name="add"]');
  if (!variantsNode || !select) return;
  let variants = [];
  try { variants = JSON.parse(variantsNode.textContent); } catch (e) { return; }
  const radios = [...productForm.querySelectorAll('input[type="radio"][name^="options"]')];
  function updateVariant() {
    const selected = [];
    [...new Set(radios.map(r => r.name))].forEach(name => { const checked = productForm.querySelector(`input[name="${CSS.escape(name)}"]:checked`); if (checked) selected.push(checked.value); });
    const variant = variants.find(v => v.options.every((value, i) => value === selected[i])) || variants.find(v => String(v.id) === select.value);
    if (!variant) return;
    select.value = variant.id;
    const option = select.querySelector(`option[value="${variant.id}"]`);
    if (price && option) price.textContent = option.dataset.price;
    if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT'; }
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
  }
  radios.forEach(r => r.addEventListener('change', updateVariant));
  select.addEventListener('change', updateVariant);
});
